import React, { createContext, useContext, useEffect, useState } from "react";
import client from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("bws_token");
    if (!token) { setLoading(false); return; }
    client.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("bws_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await client.post("/auth/login", { email, password });
    localStorage.setItem("bws_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const register = async (email, password, name) => {
    const r = await client.post("/auth/register", { email, password, name });
    localStorage.setItem("bws_token", r.data.token);
    setUser(r.data.user);
    return r.data.user;
  };

  const logout = () => {
    localStorage.removeItem("bws_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
